export default {"src":"/_next/static/media/ukraine.309f8f15.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};